import Icon1 from "../../../../../assets/images/png/courses/icons/icon1.svg";
import Icon2 from "../../../../../assets/images/png/courses/icons/icon2.svg";
import Icon3 from "../../../../../assets/images/png/courses/icons/icon3.svg";

import Icon10 from "../../../../../assets/images/png/courses/icons/icon10.svg";
import Icon8 from "../../../../../assets/images/png/courses/icons/icon8.svg";
import Icon9 from "../../../../../assets/images/png/courses/icons/icon9.svg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/chigozie.jpg";
import Instructor3 from "../../../../../assets/images/png/courses/instructors/damilola.webp";
import Instructor2 from "../../../../../assets/images/png/courses/instructors/tolu.jpg";

import Testimony2 from "../../../../../assets/images/png/courses/testimonies/curve-testimony/okoli.webp";

import ElohoImage from "../../../../../assets/images/png/courses/testimonies/eloho.png";
import VivienImage from "../../../../../assets/images/png/courses/testimonies/vivien.png";
import AdegbolaImage from "../../../../../assets/images/png/courses/testimonies/adegbola.png";
import EmenikeImage from "../../../../../assets/images/png/courses/testimonies/emenike.png";
import FaithEkeImage from "../../../../../assets/images/png/courses/testimonies/faithEke.png";
import OlajumokeOwoeyeImage from "../../../../../assets/images/png/courses/testimonies/olajumokeowoeye.png";
import KemmiImage from "../../../../../assets/images/png/courses/testimonies/kemmi.png";
import AdebayoImage from "../../../../../assets/images/png/courses/testimonies/adebayo.png";
import BasilImage from "../../../../../assets/images/png/courses/testimonies/basil.png";
import AbdulmateenImage from "../../../../../assets/images/png/courses/testimonies/abdulmateen.png";
import JanetImage from "../../../../../assets/images/png/courses/testimonies/janet.png";
import MaleeqImage from "../../../../../assets/images/png/courses/testimonies/maleek.png";

import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import BusinessPreview from "../../../../../assets/images/jpeg/bapmPreview.jpg";

export const businessAnalysisEurope = {
  id: 1,
  tag: "FOR STARTERS",
  title: "Business Analysis and Project Management Bootcamp",
  description: `
  The Utiva Business Analysis and Project Management Bootcamp is designed to help you learn the skills, tools, 
  and techniques used in a global environment and bring the practices 
  of technology into your learning experience. 
    `,
  duration: "4 months",
  downloadBrochureUrl:
    "https://drive.google.com/file/d/1Qmm1k1k1Xkuj2hjd9MA8TI3urs71AcI2/view?usp=sharing",

  bookCallUrl: "https://calendar.app.google/W9uJ5PxuwoottUjt6",
  chatWithUsUrl: "https://wa.me/12028217864",

  courseFormUrl: "courses/business-analysis-bootcamp/fill-form",

  jobTitle: "Business Analyst",

  kickoffDate: "December 2",
  kickoffTime: <>Saturday 4:00 PM - 8:00 PM (GMT+1)</>,

  testimonial: {
    image: Testimony2,
    name: "Kenchukwu Okoli",
    role: "Business Analyst",
    testimony: `
    Learning with Utiva has been very intense. I have 
      been drilled with the necessary skills and attitude that a business analyst
      practicing in the industry  should have. Areas covered in the training are 
      areas in business that existing BA providers use to 
      carry out their day to day task. Tutoring is being led by experienced business 
      expert currently practicing in the industry. He has given us practical analytical 
      projects to execute and write technical report and blogs about what we have 
      learnt, this is to reinforce the knowledge so that it sticks. It's been so beneficial. 
      I wish the program never ends. 
      Everyone should hurry and join the Utiva community now.`,
    starRating: "5.0",
  },

  courseOverview: {
    title: `Reviewed by industry leaders, the course uses 
    a project-based learning model to provide hands-on experience 
    with latest business analysis tools in preparation for the 
    CBAP® Certification examination
    `,
    desc: `
    Business Analysts play an incredibly important role as they help to decipher the future 
    of businesses, by identifying, creating and scoping valuable changes and enhancements 
    to business processes. Throughout this course, you will work on Capstone projects and 
    assignments which will help you earn the Utiva certificate in business analysis, 
    in preparation for CBPA® Certification Examination.

    `,
  },

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Stakeholder Management & Strategy Analysis",
      unitTag: "Management",
      unitDescription: `
      This course provides a holistic understanding of the business analysis field, 
      equipping you with the necessary knowledge to work collaboratively with stakeholders, 
      analyse business strategies, apply various analysis techniques, and create effective 
      strategy documents. Additionally, it covers the fundamentals of the software development 
      life cycle, ensuring that you have a solid foundation in understanding how software is 
      created and the processes that drive successful product delivery
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Create a stakeholder matrix",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Analyse a business strategy and define a Business Case for a  project",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Analyse a business idea via CBA",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 2,
      unitTitle: "Software Engineering Fundamentals for a Business Analyst",
      unitTag: "SDLC",
      unitDescription: `
      This course provides a thorough exploration of different methodologies 
      like Agile, Waterfall, and Hybrid, allowing you to understand their nuances, 
      strengths, and applications. Additionally, it delves into the Software Development 
      Life Cycle (SDLC), providing you with a comprehensive understanding of the 
      various stages and models. Furthermore, it emphasizes the importance of systems 
      thinking, enabling you to analyze problems holistically and develop effective 
      solutions by considering the interconnectedness of various components.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Analyse a software using System Thinking",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Find a software that has already been built and in the market in the right industry with the project that you are working",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 3,
      unitTitle: "Requirement Elicitation, Documentation and Management",
      unitTag: ``,
      unitDescription: `
      This comprehensive course covers various aspects of requirements management, 
      starting from understanding different requirement types to elicitation techniques, 
      documentation, and solution definition. It equips you with the necessary skills 
      to effectively gather, analyze, and document requirements, ensuring successful 
      project outcomes.
          `,

      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Prepare an elicitation activity plan for a project",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Create requirements documentation - 'Draw.io'",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle: "Create a use case diagram",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 4,
      unitTitle: "Wireframing & Software Testing",
      unitTag: `Figma`,
      unitDescription: `
      This course provides practical guidance on wireframing, software testing, 
      and assessing system changes. It covers essential skills such as creating 
      wireframes, following best practices, using design tools like Figma, understanding 
      the software testing lifecycle and stages, developing test plans and test cases, 
      and evaluating system changes for requirement conformance. By the end of the 
      course, you'll be equipped with the knowledge and skills needed to effectively 
      wireframe, test software, and assess system changes in alignment with project 
      requirements.
            `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Create a wireframe design using Figma",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Submit your wireframe for review",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Create a test plan and test case",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 5,
      unitTitle: "Agile Business Analysis",
      unitTag: ``,
      unitDescription: `
      This comprehensive course covers the foundations of Agile Business Analysis, 
      Agile methodologies, and the role of a business analyst in Agile teams. It 
      delves into specific Agile artifacts such as epics, user stories, and user 
      acceptance criteria, as well as the creation and management of product 
      roadmaps and backlogs. By the end of the course, you'll have a solid 
      understanding of Agile Business Analysis principles and practices, equipping 
      you to contribute effectively to Agile projects as a business analyst.
        `,

      unitFeatures: [
        {
          featureIcon: Icon9,
          featureTitle:
            "Decompose a software into Epics, User Stories and Acceptance Criteria",
          featureDescription: ``,
        },
        {
          featureIcon: Icon10,
          featureTitle:
            "Use Spreadsheets to create Epics, Userstory and define acceptance criteria",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 6,
      unitTitle: "JIRA Masterclass",
      unitTag: `JIRA`,
      unitDescription: `
      This comprehensive course covers the utilization of JIRA by business analysts 
      for backlog grooming, documentation of user stories and acceptance criteria, 
      and managing the workflow within a Scrum team. It also provides guidance on 
      creating JIRA profiles, configuring roadmaps, and understanding the key 
      elements of the JIRA user interface. By the end of the course, you'll have 
      a solid understanding of how to effectively utilize JIRA as a business 
      analyst in Agile projects, from backlog management to workflow facilitation.
        `,

      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Create a JIRA account",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Create a project on JIRA",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 7,
      unitTitle: "Business Process Management",
      unitTag: ``,
      unitDescription: `
      This comprehensive course covers the fundamentals of process discovery, 
      modeling, and documentation. It provides guidance on techniques for 
      uncovering existing processes, modeling them using BPMN, and analyzing 
      them for improvement. Additionally, it covers the process documentation process, 
      from capturing the current state (as-is) to designing the future state (to-be). 
      By the end of the course, you'll have the necessary skills to effectively 
      discover, model, analyze, and document business processes.
        `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle:
            "Map a process with BPMN and analyse the process identify gaps",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle: "Create a business process documentation",
          featureDescription: ``,
        },
        {
          featureIcon: Icon3,
          featureTitle: "Use Draw.io",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 8,
      unitTitle: "Change Management & Solution Evaluation",
      unitTag: ``,
      unitDescription: `
        This comprehensive course covers the fundamentals of change management in 
        the context of solution delivery. It includes an understanding of change 
        management models, documentation such as the RFC, practical implementation of 
        change management processes, measuring solution performance using KPIs, and 
        analyzing performance data. By the end of the course, you'll have the necessary 
        knowledge and skills to effectively manage change and assess solution 
        performance within a delivery context.
            `,
      unitFeatures: [
        {
          featureIcon: Icon1,
          featureTitle: "Create a change management strategy",
          featureDescription: ``,
        },
        {
          featureIcon: Icon2,
          featureTitle:
            "Define performance measures to evaluation a mock solution",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 9,
      unitTitle: "Understanding relationships between data elements",
      unitTag: ``,
      unitDescription: `
        This comprehensive course covers the essential topics of data dictionary, 
        data modeling, and the role of a business analyst in data migration. It 
        provides insights into creating and maintaining a data dictionary, 
        understanding data modeling techniques, and the responsibilities of a 
        business analyst in data migration projects. By the end of the course, 
        you'll have the necessary knowledge and skills to effectively utilize data 
        dictionaries, create data models, and contribute to data migration initiatives 
        as a business analyst.
              `,
      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Create an Entity Relationship Model",
          featureDescription: ``,
        },
        {
          featureIcon: Icon9,
          featureTitle: "Create a Data Dictionary",
          featureDescription: ``,
        },
      ],
    },
    {
      unitId: 10,
      unitTitle: "SQL Essentials",
      unitTag: `SQL`,
      unitDescription: `
        This comprehensive course covers the fundamentals of databases, SQL querying, 
        and database management using Microsoft SQL Server Management Studio. It 
        provides guidance on creating tables, inserting and modifying data, querying 
        data with different clauses, and managing database objects. Additionally, it 
        covers advanced topics such as joins and views for data retrieval and 
        manipulation. By the end of the course, you'll have a solid understanding of 
        database concepts and SQL skills necessary for working with databases using 
        SQL Server Management Studio.
                `,
      unitFeatures: [
        {
          featureIcon: Icon8,
          featureTitle: "Perform SQL operations on a data set",
          featureDescription: ``,
        },
      ],
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Chigozie Muogbo",
      coachRole: "IT Business Analyst, BNP Paribas",
    },
    {
      coachId: 2,
      coachImage: Instructor2,
      coachName: "Tolu Awoyemi",
      coachRole: "Business Analyst, Salesplat Technology",
    },
    {
      coachId: 3,
      coachImage: Instructor3,
      coachName: "Damilola Ojo",
      coachRole: "Business Analyst, Custodian Investment",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "HANDS ON TRAINING",
      modelDescription:
        "Practical sessions with the use of tools like Jira, Draw.io",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "VIRTUAL CLASSES",
      modelDescription:
        "A 2months experiential learning and hands-on Instructor-led virtual classes.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "BUSINESS CASE-FOCUSED",
      modelDescription:
        "Work on real-life projects by applying what you learn to solve related business problems.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "PEER-TO-PEER SESSIONS",
      modelDescription:
        "Share knowledge with other fellows and gain multidimensional perspectives of problem-solving",
    },
    {
      modelId: 5,
      modelIcon: AlunmiImage,
      modelTitle: "ACCESS CONTENTS",
      modelDescription: "50% on your own + 50% in live classes",
    },
  ],

  studentTestimonies: [
    {
      id: 1,
      linkedIn: "",
      image: "",
      firstname: "Wills",
      lastname: "Nancy",
      company: "",
      testimony: `
      I am currently enrolled in the Business Analysis and Project Management program at Utiva, and my experience so far has been very positive. Utiva provides a learning environment that combines flexibility, practical learning, and strong support for students, which makes the program very engaging.
      `,
    },
    {
      id: 2,
      linkedIn: "",
      image: "",
      firstname: "Mojisola",
      lastname: "Fafowora",
      company: "",
      testimony: `
      My learning has been really educating so far, learning new skills and terminologies in the Business Analysis and project management program. Mrs Kome is a good teacher and she explains throughly. Although for the project management videos in the Platform, I think it was rushed and not explained in details enough for someone with zero knowledge of PM. The Business Analysis videos were good.
      `,
    },
    {
      id: 3,
      linkedIn: "",
      image: ElohoImage,
      firstname: "Eloho",
      lastname: "Igwe",
      company: "",
      testimony: `
      One standout for me has been my trainer, Coach Kome. She is incredibly patient and takes the time to ensure everyone understands each concept before moving forward. I have had a great experience in the BAPM class so far.
      `,
    },
    {
      id: 4,
      linkedIn: "",
      image: "",
      firstname: "Alone",
      lastname: "Cool",
      company: "",
      testimony: `
      Project management & Business Analysis, It's educating, the teacher is amazing, am looking forward to more, the teacher is engaging, the improvement needed is on the network issues... but in all honesty I look out for more, more enticing method to keep glued and looking forward to classes, ways to show the students this is real not looking like a waste of time.
      `,
    },
    {
      id: 5,
      linkedIn: "",
      image: VivienImage,
      firstname: "Vivien",
      lastname: "Ebere",
      company: "",
      testimony: `
      Currently studying Business Analysis and Project Management at Utiva and so far it's been a good experience, Omobosola has been particularly helpful, great trainer, always making sure we're all on the same page and no one is left behind. It's a very flexible program for busy professionals and i appreciate how helpful everyone at Utiva has been so far.
      `,
    },
    {
      id: 6,
      linkedIn: "",
      image: AdegbolaImage,
      firstname: "Roseline",
      lastname: "Adegbola",
      company: "",
      testimony: `
      I really enjoy the learning process of each session, I am able to learn at my own pace which makes me research and apply to assignments given. Also my Tutor's teaching are simplified for me enough to study.
      I really appreciate the opportunity to be a part of this. With the knowledge so far i have been able to analyze how big projects are being managed. And I look forward to implementing to my projects in the future upon the completion of this course.
      `,
    },
    {
      id: 7,
      linkedIn: "",
      image: EmenikeImage,
      firstname: "Emenike",
      lastname: "Okorie",
      company: "",
      testimony: `
      My experience on the Utiva has been enriching and rewarding. I enrolled in the Business Analyst and Project Management Training December 2025 Boot Camp, which is designed to equip participants with practical knowledge and industry-relevant skills. The course is well structured and covers essential topics, and I have been able to navigate work and this training, this can only be possible with Utiva.

      The highlights of the training so far for me has been the excellent guidance provided by my trainer, Mrs. Oghenekoma Oba. She has demonstrated deep knowledge of the subject matter and explained complex concepts in a clear and understandable manner. Her teaching style encourages participation, questions, and practical discussions, which has made the learning process engaging and effective.

      The training materials, examples, and practical exercises has helped reinforce the concepts learned during the sessions. I particularly appreciate how real-life scenarios are used to illustrate business analysis and project management practices.

      Overall, the course is very beneficial and provides valuable insights that can be applied in professional environments. I am grateful to Mrs. Oghenekoma Oba for her dedication and professionalism in the training sessions so far. I highly recommend this course to anyone interested in developing their skills in business analysis and project management and Utiva as the training platform to acquire such skills because of there seasoned and experienced trainers.
      `,
    },
    {
      id: 8,
      linkedIn: "",
      image: FaithEkeImage,
      firstname: "Faith",
      lastname: "Ekeakhogbe",
      company: "",
      testimony: `
      My experience at Utiva academy while studying Business analysis and project management (BAPM) so far as been insightful and rewarding. The training is well structured and provides practical knowledge on analyzing solutions, and understanding how projects are managed in real-world environment. The learning process has been engaging and continues to strengthen my analytical thinking and problem-solving skills.
      I'm sincerely grateful to my trainer Dr. Mrs Kome, for her guidance, patience and dedication throughout the program. She explained complex concepts clearly, make me understand every lessons taught bit by bit and encouraged active participation, making the learning process engaging and impactful.
      Finally, the experience so far has strengthened my analytical, problem-solving and project management skills, and I truly appreciate the supportive learning environment and quality training provided and also, I look forward to continuing the program and gaining even more valuable knowledge and experience.
      `,
    },
    {
      id: 9,
      linkedIn: "",
      image: OlajumokeOwoeyeImage,
      firstname: "Olajumoke",
      lastname: "Owoeye",
      company: "",
      testimony: `
      I'm studying Business Analysis and Project management at Utiva, taught by Mrs Kome.
      The experience has been great. I'm able to watch the lessons at my convenience and attend live classes on weekends where we have practicals. The assignments makes me review the lessons and read further on the topics.
      `,
    },
    {
      id: 10,
      linkedIn: "",
      image: KemmiImage,
      firstname: "Kemmi",
      lastname: "Yomi-Amusa",
      company: "",
      testimony: `
      It's 3weeks into my Business Analysis and Project Management training and it's been amazing. I love the fact that we have weekly assignments that ensure lessons for the week are put to practice.
      `,
    },
    {
      id: 11,
      linkedIn: "",
      image: AdebayoImage,
      firstname: "Adebayo",
      lastname: "Ishola",
      company: "",
      testimony: `
      The Business Analysis and Project Management Course at Utiva is a top notch curriculum, the Trainer Tolu Awoyemi broke down the concept well and the sessions were very practical. Thank you
      `,
    },
    {
      id: 12,
      linkedIn: "",
      image: BasilImage,
      firstname: "Basil",
      lastname: "Okorie",
      company: "",
      testimony: `
      My Tutor(BAPM) is well Knowledgeable and good. Utiva to the world.
      `,
    },
    {
      id: 13,
      linkedIn: "",
      image: AbdulmateenImage,
      firstname: "Abdulmateen",
      lastname: "Yusuf",
      company: "",
      testimony: `
      Utiva's BA/PM Course is a robust with the curriculum, the Coach Tolu Awoyemi knows his onions well with explanation of the concepts well and the sessions were hands on practical.
      `,
    },
    {
      id: 14,
      linkedIn: "",
      image: JanetImage,
      firstname: "Janet",
      lastname: "Ayokunle",
      company: "",
      testimony: `
      Such an amazing and insightful learning journey. Most especially the Business Analysis and Project Management Trainer, Mr Tolu Awoyemi, He is such an excellent trainer. He obviously knows his onions.
      `,
    },
    {
      id: 15,
      linkedIn: "",
      image: MaleeqImage,
      firstname: "Maleeq",
      lastname: "Oshaf",
      company: "",
      testimony: `
      I recently completed the Business Analysis Programme under Tolu Awoyemi's expert guidance, and I am thrilled to provide this feedback.

      Overall Assessment
      The training programme was exceptional, and Tolu Awoyemi demonstrated outstanding expertise in business analysis. The sessions were engaging, informative, and well-structured, providing a comprehensive understanding of the subject matter.

      Strengths:
      - Tolu Awoyemi has a deep understanding of business analysis concepts and was able to convey complex ideas in a clear and concise manner.
      - The training materials were relevant, up-to-date, and well-organized.
      - Tolu Awoyemi encouraged active participation, fostered a collaborative learning environment, and was responsive to questions and concerns.

      Areas of Excellence:
      - Tolu Awoyemi provided practical examples and case studies that helped illustrate key concepts and their application in real-world scenarios.
      - The training programme was well-paced, allowing participants to absorb and reflect on the material.

      Recommendations for Future Improvements:
      None, as the programme met my expectations and delivered valuable insights.

      Rating: 5/5 (Excellent)

      Conclusion:
      I highly recommend Tolu Awoyemi as a trainer for business analysis programmes. The training programme was informative, engaging, and relevant to my professional needs. I appreciate Tolu Awoyemi's expertise, enthusiasm, and dedication to delivering high-quality training.
      `,
    },
  ],

  portofolio: {
    title: "Build Solutions around Real-life Business Cases",
    description: `
    Through the Utiva Business Analytics Course, you will learn what 
    makes competent Business Analysts and work on real-world projects 
    developed by industry experts. Every week in your business analysis classes, 
    you'll be provided with clear actionable steps to iteratively develop your 
    project. With real-world projects and immersive content built in partnership 
    with top-tier companies, you’ll master the skills companies require. 
      `,
    name: "James Miles",
    // image: PortfolioUserAvatar,
    // portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva Business Analysis Certification",
    description: `
    Upon completing Utiva's Business Analysis  Course, you'll receive an 
    industry-recognized, professional Business Analysis certification to 
    share with your network and showcase all that you've 
    learned. Utiva certificates are formatted for sharing on LinkedIn 
      `,
  },

  videoTestimonial: "https://www.youtube.com/embed/T005noz-SRo",
  videoPreviewImage: BusinessPreview,

  otherCourses: [
    {
      id: 1,
      courseTitle: "Cloud Bootcamp",
      courseDescription: `This training is designed to help you move into a new tech job 
      within 3 months. That is our goal and hope you are ready for this. You learn the latest skills of the 
      Cloud Developer using the Microsoft Azure program, you will learn how to 
      deploy, build, migrate, and monitor applications on Azure. `,
      courseUrl: "/courses/cloud-bootcamp",
    },
  ],
};
